import React from 'react';
import { render } from 'react-dom';
import { Provider } from 'react-redux';
import { Route, Switch } from 'react-router-dom';
import { createBrowserHistory } from 'history'
import { ConnectedRouter } from 'react-router-redux';

import store from 'stores/';
import App from 'containers/App';
import AuthService from 'services/AuthService';

const history = createBrowserHistory({
  basename: process.env.BASENAME
});

AuthService.interceptorRequest();
AuthService.interceptResponse();

render(
  <Provider store={store}>
    <ConnectedRouter history={history}>
      <Switch>
        <Route path="/" component={App} />
      </Switch>
    </ConnectedRouter>
  </Provider>,
  document.getElementById('app-container')
);



// WEBPACK FOOTER //
// ./index.js